import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { fetchWithAuth } from '../utils/apiHelper'; // Importa la función fetchWithAuth

const Login = ({ setIsAuthenticated }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (event) => {
    event.preventDefault();

    try {
      const data = await fetchWithAuth('/auth/login', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ username, password })
      });

      if (data.token) {
        localStorage.setItem('token', data.token);
        localStorage.setItem('sucursalNombre', data.sucursal_nombre);
        localStorage.setItem('nombreUsuario', data.username);
        localStorage.setItem('admin', data.is_admin);
        toast.success('Inicio de sesión exitoso', {
          onClose: () => {
            setTimeout(() => {
              setIsAuthenticated(true);
              navigate('/');
            }, 1000);
          }
        });
      } else {
        toast.error('Error en el inicio de sesión: ' + data.message);
      }
    } catch (error) {
      console.error('Error en el inicio de sesión:', error);
      toast.error('Error en el inicio de sesión.');
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-pink-100 via-purple-100 to-pink-200 px-4">
      <div className="w-full max-w-md p-8 bg-white/60 backdrop-blur-md rounded-xl shadow-xl border border-white/30">
        <h2 className="text-3xl font-semibold text-center text-pink-600 mb-6">Bienvenida a Belleza Nails</h2>
        <form onSubmit={handleSubmit} className="space-y-5">
          <div>
            <label htmlFor="username" className="block text-sm font-medium text-gray-700 mb-1">
              Usuario
            </label>
            <input
              id="username"
              name="username"
              type="text"
              required
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              className="w-full px-4 py-3 rounded-lg border border-pink-200 focus:outline-none focus:ring-2 focus:ring-pink-400 focus:border-pink-400 transition placeholder-gray-400 text-gray-800 bg-white/70"
              placeholder="Ingresa tu usuario"
            />
          </div>
          <div>
            <label htmlFor="password" className="block text-sm font-medium text-gray-700 mb-1">
              Contraseña
            </label>
            <input
              id="password"
              name="password"
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full px-4 py-3 rounded-lg border border-pink-200 focus:outline-none focus:ring-2 focus:ring-pink-400 focus:border-pink-400 transition placeholder-gray-400 text-gray-800 bg-white/70"
              placeholder="Ingresa tu contraseña"
            />
          </div>
          <div>
            <button
              type="submit"
              className="w-full py-3 bg-pink-500 text-white rounded-lg font-medium hover:bg-pink-600 transition duration-300 shadow-md hover:shadow-lg"
            >
              Iniciar Sesión
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Login;
